import { Button } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import CrossIcon from "../../icons/CrossIcon";
import DeleteIcon from "../../icons/DeleteIcon";

const CheckboxQuestion = ({
  questionId,
  onDelete,
  questionHandler,
  ...rest
}) => {
  const [question, setQuestion] = useState({
    title: "",
    answers: [],
    correct_answers: [],
    sequence: null,
    question_type: "multiple_selection",
    answer_explanation: null,
  });

  const onChangeHandler = (e, index) => {
    const { name, value } = e.target;

    if (name === "answers") {
      let changedAnswer = [...question.answers];
      changedAnswer[index] = value;

      setQuestion({
        ...question,
        answers: changedAnswer,
      });
    } else if (name === `correct_answers ${questionId}`) {
      let changedAnswer = [...question.correct_answers];
      if (changedAnswer.includes(question.answers[index])) {
        const activeValues = changedAnswer.filter((item) => {
          return item !== question.answers[index];
        });
        setQuestion({
          ...question,
          correct_answers: activeValues,
        });
      } else {
        setQuestion({
          ...question,
          correct_answers: [...changedAnswer, question.answers[index]],
        });
      }
    } else {
      setQuestion({
        ...question,
        [name]: value,
      });
    }
  };

  const addOptionHanlder = () => {
    setQuestion({
      ...question,
      answers: [...question.answers, ""],
    });
  };

  const removeOptionHandler = (id) => {
    const activeOptions = question.answers.filter((item) => {
      return item !== question.answers[id];
    });
    setQuestion({
      ...question,
      answers: activeOptions,
    });
  };

  useEffect(() => {
    if (
      question.title &&
      question.answers.length > 1 &&
      question.correct_answers.length > 0
    ) {
      questionHandler(questionId, {
        ...question,
        answers: question.answers.filter((item) => {
          return item !== "";
        }),
        correct_answers: question.correct_answers.filter((item) => {
          return item !== "";
        }),
      });
    }
  }, [question]);

  return (
    <div
      className="bg-white p-4 rounded-3 shadow mb-4 assessment_question"
      {...rest}
    >
      <div className="mb-2"><i>Multi-Choice question</i></div>
      <div className="d-flex align-items-center justify-content-between">
        <TextArea
          type="text"
          name="title"
          autoSize={{minRows:1}}
          onChange={onChangeHandler}
          placeholder="Question Title"
          className="w-75 ant-input assessment_question_title"
        />

        <DeleteIcon width="18" height="18" onClick={onDelete} />
      </div>

      {question.answers.map((item, i) => {
        return (
          <div
            className="align-items-center d-flex justify-content-between mt-3"
            key={i}
          >
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                name={`correct_answers ${questionId}`}
                value={question.correct_answers[i]}
                onChange={(e) => onChangeHandler(e, i)}
                disabled={!question.answers[i]}
              />
              <input
                type="text"
                name="answers"
                onChange={(e) => onChangeHandler(e, i)}
                className="ant-input ml-3"
                placeholder={`Option ${i + 1}`}
                value={question.answers[i]}
              />
            </label>

            <CrossIcon
              width="16"
              height="16"
              className="dynamic-delete-button"
              onClick={() => removeOptionHandler(i)}
            />
          </div>
        );
      })}

      <Button
        onClick={() => addOptionHanlder()}
        type="secondary"
        className="mt-3"
      >
        Add Option
      </Button>
    </div>
  );
};

export default React.memo(CheckboxQuestion);
